class Category {
  constructor(updatedBy, info) {
    this.customerId = info.customerId;
    this.name = info.name;
    // this.categoryId = info.categoryId;
    this.parentCategory = info.parentCategory;
    this.description = info.description;
    this.categoryImage = info.categoryImage;
    this.updatedBy = updatedBy;
    this.ondcCategoryId = info.ondcCategoryId;
    this.domain = info.domain;
  }
}

export default { Category };
export { Category };



